import React from "react";
import { Comment } from "../lib/types/CommentType";

export interface ICommentsContext {
  comments: Comment[];
  deleteComment: (commentId: number) => void;
  submitComment: (comment: string, email: string) => void;
  fetchComments: () => void;
  commentsLoading: boolean;
}

export const CommentsContext = React.createContext<
  ICommentsContext | undefined
>(undefined);
